<template>
  <div>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />
        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />

      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>
      <v-list-item-group
        multiple
        active-class=""
        class="mt-5 px-6"
      >

        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Image"
          v-model="sectionData[sectionData.type].thumbnail"
          :errorMessages="imageError(head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type +  '.thumbnail' ]))"
        />

        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Thumbnail Image"
          v-model="sectionData[sectionData.type].thumbnail_mobile"
          :errorMessages="imageError(head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type +  '.thumbnail_mobile' ]))"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].url"
          outlined
          label="URL"
          :error-messages="head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type +  '.url' ])"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].image_alt_text"
          outlined
          label="Image Alt Text"
        />
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ColorPicker from '@/components/ColorPicker'
import head from 'lodash/head'

export default {
  name: 'PageImageDropper',
  components: {
    ImageFileInputViewer,
    ColorPicker
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return {}
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    currIndex: {
      type: [String, Number],
      default: null
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    }
  },

  methods: {
    head,
    imageError (errorString) {
      if (errorString) {
        return 'Image input is required'
      } else {
        return null
      }
    }
  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
